















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class InputReadOnlyWithButton extends Vue {
  @Prop({ default: "発注先" }) label!: string;
  @Prop({ default: "" }) name!: string;
}
